import { PRIZES_SERVICE } from "@/services/prizes.service.js";

const state = { listOutput: null};

const actions = {
    getList({ dispatch, commit }, inputGetPrizes) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        PRIZES_SERVICE.list(inputGetPrizes)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
};

export const prizes = {
    namespaced: true,
    state,
    actions,
    mutations
};